export const ORDER_STATUS = ["Pending", "Processing", "Shipped", "Delivered", "Canceled"]